import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  assignPitchContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    flexWrap: 'wrap',
    '@media (min-width: 640px)': {
      width: 'max-content',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  facetInputs: {
    position: 'absolute',
    width: '48px',
    border: `1px solid ${theme.evPalette.charcoal[900]}`,
    borderRadius: '4px',
    '&.error': {
      backgroundColor: theme.evPalette.rose[100],
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },
  editPitchesControls: {
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    padding: '10px 8px',
    gap: '6px',
    boxShadow: 'none',
    flexDirection: 'column',
    width: '100%',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      width: 'min-content',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  },
  assignPitchLabel: {
    color: theme.evPalette.charcoal[900],
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  assignPitchInput: {
    '&.error': {
      backgroundColor: theme.evPalette.rose[100],
      '& fieldset': {
        borderColor: `${theme.evPalette.rose[900]} !important`,
      },
    },
    flex: 1,
    '&>div': {
      height: '44px',
      width: '100%',
    },
    '@media (min-width: 640px)': {
      flex: 'unset',
      '&>div': {
        width: '98px',
      },
    },
  },
  invalidPitchAlert: {
    width: '100%',
    backgroundColor: theme.evPalette.rose[100],
  },
  invalidPitchMsg: {
    color: theme.evPalette.charcoal[900],
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  invalidPitchAlertIcon: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  zoomSliderContainer: {
    padding: 10,
    backgroundColor: theme.evPalette.charcoal[100],
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    width: '100%',
    boxShadow: 'none',
    '@media (min-width: 640px)': {
      width: '300px',
    },
    '&>*': { padding: 0 },
  },
  applyBtn: {
    height: '44px',
    width: '85px',
    backgroundColor: theme.evPalette.ocean[900],
    color: theme.evPalette.salt[100],
  },
}));
